import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalT1 = () => {

return(
<div>
    
<Typography variant="h6" >

VPresence of an rs3087243(G) allele represents a 1.5 fold increased risk (genotype G/A) of autoimmune thyroid disease, and for those with autoimmune thyroid disease, a 1.5 fold increased risk of type-1 diabetes (mainly Asia population).
However, in individuals without autoimmune thyroid disease, no association was seen between this SNP and type-1 diabetes. 
The authors speculate that earlier studies may have reported associations between this SNP and type-1 diabetes that were actually primarily based on the association with autoimmune thyroid disease. (SNPedia)<br /><br />

This same SNP, rs3087243, has also been implicated as a (minor) risk factor for developing rheumatoid arthritis (RA). A study of 2,000+ European RA patients led to a calculated odds ratio of 1.13 . <br /><br />

The rs4880(T) allele, part of the codon for amino acid valine at codon 16 of the antioxidant protein from the mitochrondrial superoxide dismutase 2 SOD2 gene, 
is the most common in most populations studied. The rs4880(C) allele gives rise to an alanine at this position is it also known as Val16Ala manganese superoxide dismutase, or A16V.

<br /><br /> 

Sources:
SNPedia  <br /><br />

 
</Typography>

</div>
)
}